import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as JoyBuddy } from '../../../../../../assets/icons/buddy-joy.svg';
import CardNE from '../../../../../../shared/components/CardNE/CardNE';
import Tag from '../../../../../../shared/components/Tag/Tag';
import { TRANSLATION_POINTS_BY_FILE } from '../../../../../../shared/translations/rewards';
import './SuccessCard.scss';

interface SuccessCardProps {
  orderNumber: string;
}

const SuccessCard = ({ orderNumber }: SuccessCardProps) => {
  const { t } = useTranslation();

  return (
    <CardNE className="justify-between gap-6 w-1/3 rewards-points-success-card h-auto" data-experience="new">
      <div className="flex flex-column h-100 gap-6 ">
        <div className="ne-genpage-image-container">
          <JoyBuddy width={80} height={80} />
        </div>
        <div className="flex flex-column gap-4">
          <div>
            <Tag type="white" text={t(TRANSLATION_POINTS_BY_FILE.success.tag, { order: orderNumber })} curved={true} />
          </div>

          <div className="ne-font-heading-md">{t(TRANSLATION_POINTS_BY_FILE.successWithErrors.successCard.title)}</div>
          <div className="ne-font-body-sm">{t(TRANSLATION_POINTS_BY_FILE.success.description)}</div>
        </div>
      </div>
    </CardNE>
  );
};

export default SuccessCard;
